module.exports = __webpack_public_path__ + "img/adm-icon.82178f90.svg";